import React, { useState } from 'react';
import { profileApi } from '../../../services/api';
import AddEditModal from '../shared/AddEditModal';
import ItemCard from '../shared/ItemCard';

const awardFields = [
    { name: 'title', label: 'عنوان الجائزة', type: 'text', required: true, placeholder: 'موظف العام' },
    { name: 'issuer', label: 'الجهة المانحة', type: 'text', required: true, placeholder: 'اسم الشركة أو المنظمة' },
    { name: 'date', label: 'التاريخ', type: 'month', required: true, placeholder: '2023-06' },
    { name: 'description', label: 'الوصف', type: 'textarea', placeholder: 'وصف موجز للجائزة ولماذا حصلت عليها' },
    { name: 'importance', label: 'الأهمية', type: 'importance' }
];

export default function Awards({ profile, onRefresh }) {
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const awards = profile?.awards || [];

    const handleAdd = () => {
        setEditItem(null);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذه الجائزة؟')) return;
        setLoading(true);
        try {
            await profileApi.deleteAward(id);
            onRefresh('awards');
        } catch (err) {
            alert('فشل في حذف الجائزة');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (editItem) {
                await profileApi.updateAward(editItem.id, data);
            } else {
                await profileApi.addAward(data);
            }
            setShowModal(false);
            onRefresh('awards');
        } catch (err) {
            alert('فشل في حفظ الجائزة');
        } finally {
            setLoading(false);
        }
    };

    const renderCard = (award) => (
        <ItemCard
            key={award.id}
            title={award.title}
            subtitle={award.issuer}
            meta={[
                award.date && new Date(award.date).toLocaleDateString('ar-SA', { year: 'numeric', month: 'long' })
            ].filter(Boolean)}
            description={award.description}
            importance={award.importance}
            onEdit={() => handleEdit(award)}
            onDelete={() => handleDelete(award.id)}
        />
    );

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">الجوائز والتقدير</h2>
                <button className="add-button" onClick={handleAdd}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    إضافة جائزة
                </button>
            </div>

            {awards.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
                            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                            <path d="M4 22h16"></path>
                            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
                            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
                            <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
                        </svg>
                    </div>
                    <h3 className="empty-state-title">لا توجد جوائز بعد</h3>
                    <p className="empty-state-description">أضف الجوائز والتقدير الذي حصلت عليه</p>
                    <button className="add-button" onClick={handleAdd}>أضف جائزتك الأولى</button>
                </div>
            ) : (
                <div className="items-grid">
                    {awards.map(renderCard)}
                </div>
            )}

            {showModal && (
                <AddEditModal
                    title={editItem ? 'تعديل الجائزة' : 'إضافة جائزة'}
                    fields={awardFields}
                    initialData={editItem || {}}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
